import { useCallback, useEffect, useState, type ChangeEvent, type ReactElement } from 'react'
import ErrorComponent from '../error-component/error-component'
import type InputTextProps from './input.props'
import * as S from './input.styled'

export default function Input ({
  as = 'input',
  error,
  label,
  mask,
  name,
  onChange,
  value,
  ...rest
}: InputTextProps): ReactElement {
  const [internalValue, setInternalValue] = useState<string>('')

  const handleValueChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value

    if (mask != null) value = mask(value)

    if (onChange != null) {
      if (name != null) {
        onChange((prevValue: any) => ({ ...prevValue, [name]: value }))
        setInternalValue(value)
        return
      }

      onChange(value)
      setInternalValue(value)
    }
  },
  [mask, name, onChange])

  useEffect(() => {
    value !== undefined && setInternalValue(value)
  }, [value])

  return <S.Container>
    <S.Label htmlFor={name}>{label}</S.Label>
    <S.Input
      as={as}
      id={name}
      name={name}
      onChange={handleValueChange}
      value={internalValue !== null && internalValue !== undefined && internalValue !== '' ? internalValue : '' }
      {...rest}
    />

    { error != null && <ErrorComponent>{error}</ErrorComponent>}
  </S.Container>
}
